import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import withMainControls from 'eventbrite_design_system/structure/hoc/withMainControls';
import { TYPE_ERROR } from 'eventbrite_design_system/notification/constants';

import SetPasswordForm from '../../components/forms/SetPasswordForm';
import LookUpForm from '../../components/forms/LookUpForm';
import PageHeader from '../../components/PageHeader';
import {
    PAGE_HEADER_INFO_MAP,
    RESET_PASSWORD_PATH,
    TRIGGER_RESET_PASSWORD,
    SET_PASSWORD_PATH,
} from '../../constants';
import { getSetPasswordFormType } from '../../utils';

import AlertChunkySvg from 'eventbrite_design_system/iconography/icons/AlertChunky';

const DYNAMIC_FORM_MAP = {
    [TRIGGER_RESET_PASSWORD]: LookUpForm,
    [RESET_PASSWORD_PATH]: SetPasswordForm,
    [SET_PASSWORD_PATH]: SetPasswordForm,
};

class SetPasswordScreen extends React.PureComponent {
    static propTypes = {
        handleSetPassword: PropTypes.func.isRequired,
        handleResetPassword: PropTypes.func.isRequired,
        locale: PropTypes.string,
        hideMainNotification: PropTypes.func,
        addMainNotification: PropTypes.func,
    };

    _handleShowNotification(error) {
        const { addMainNotification } = this.props;

        /*Limit the call to addMainNotification to only if
        a notification hasn't been shown since last submit.*/
        if (!this._hasNotification) {
            addMainNotification({
                type: TYPE_ERROR,
                children: error,
                iconType: <AlertChunkySvg />,
            });

            this._hasNotification = true;
        }
    }

    _handleClearNotification() {
        const { hideMainNotification } = this.props;

        this._hasNotification = false;
        hideMainNotification();
    }

    _getFormType() {
        const {
            route: { path: formType },
            router: {
                location: { query },
            },
        } = this.props;

        return getSetPasswordFormType(formType, query);
    }

    _getSubmitAction(formType) {
        const { handleSetPassword, handleResetPassword } = this.props;

        const actionMap = {
            [TRIGGER_RESET_PASSWORD]: handleResetPassword,
            [RESET_PASSWORD_PATH]: handleSetPassword,
            [SET_PASSWORD_PATH]: handleSetPassword,
        };

        return actionMap[formType];
    }

    render() {
        const { locale } = this.props;

        const formType = this._getFormType();
        const submitAction = this._getSubmitAction(formType);
        const DynamicForm = DYNAMIC_FORM_MAP[formType];
        const shouldHideLegalCopy = formType === RESET_PASSWORD_PATH;
        const {
            headerText,
            iconType,
            subtitleText,
            buttonCTA,
        } = PAGE_HEADER_INFO_MAP[formType];

        const gridClasses = classNames(
            'eds-g-cell',
            'eds-g-cell-10-12 eds-g-offset-1-12',
            'eds-g-cell-sm-8-12 eds-g-offset-sm-2-12',
            'eds-g-cell-sw-6-12 eds-g-offset-sw-3-12',
            'eds-g-cell-md-4-12 eds-g-offset-md-4-12',
            'eds-g-cell--has-overflow',
        );

        return (
            <div className="eds-l-mar-vert-14">
                <div className="eds-g-group">
                    <div className={gridClasses}>
                        <PageHeader
                            headerText={headerText}
                            subtitleText={subtitleText}
                            iconType={iconType}
                        />
                        <DynamicForm
                            onSubmit={submitAction}
                            headerText={headerText}
                            iconType={iconType}
                            subtitleText={subtitleText}
                            buttonCTA={buttonCTA}
                            shouldHideLegalCopy={shouldHideLegalCopy}
                            locale={locale}
                            showNotification={this._handleShowNotification.bind(
                                this,
                            )}
                            clearNotification={this._handleClearNotification.bind(
                                this,
                            )}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default withMainControls(SetPasswordScreen);
